import IPOUserNavigationRoutes from "./navigationRoutes";
import IPOHomePage from "../pages/Home/IPOHomePage";
import IPOApplicationStatusPage from "../pages/IPOApplicationStatusPage";

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: IPOUserNavigationRoutes.IPO_HOME,
    component: IPOHomePage,
    name: "IPO Home",
  },
];

// Auth routes that require authentication
const authRoutes: Array<{
  path: string;
  component: React.ComponentType;
  name: string;
}> = [
  {
    path: IPOUserNavigationRoutes.IPO_APPLICATION_STATUS,
    component: IPOApplicationStatusPage,
    name: "IPO Application Status",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
